
import { deep_merge_adv } from "@matchlighter/common_library/lib/deep/deep_sync_adv";

export function deep_duplicate<T>(obj: T): T {
    const target = Array.isArray(obj) ? [] : {};
    return deep_merge_adv(target, obj) as T;
}

let uniqueId = 0;
export function getNextId() {
    return ++uniqueId
}

export function getItemKey(item: any, defaultValue?: any) {
    const keys = ['id', 'uuid', 'cid'];
    for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        if (i == keys.length - 1 && defaultValue == null && item[k] == null) {
            item[k] = getNextId();
        }
        if (item[k]) return `${k}:${item[k]}`;
    }
    return defaultValue;
}

export function flatten<T>(arr: any[]): T[] {
    return arr.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
  }
  
